import * as actionType from "./affiliateActionType";

const initialState = {
  isLoading: false,
  isSaved: false,
  isAffiliateLoggedIn: sessionStorage.getItem('loggedAffiliate') !== null ? true : false,
  loggedAffiliate: sessionStorage.getItem('loggedAffiliate') !== null ? JSON.parse(sessionStorage.getItem('loggedAffiliate')) : {},
  orders: [],
  orderCount: { completed: 0, pending: 0 },
  isSent: false,
  isReset: false
};

export const affiliateReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionType.AFFILIATE_CREATE:
            return {
                ...state,
                isLoading: true,
                isSaved: false
            };
        case actionType.AFFILIATE_CREATE_FAILURE:
            return {
                ...state,
                isLoading: false,
            };
        case actionType.AFFILIATE_CREATE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSaved: true
            };
        case actionType.AFFILIATE_LOGIN:
            return {
                ...state,
                isLoading: true,
                isAffiliateLoggedIn: false
            };
        case actionType.AFFILIATE_LOGIN_FAILURE:
            return {
                ...state,
                isLoading: false,
                isAffiliateLoggedIn: false
            };
        case actionType.AFFILIATE_LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isAffiliateLoggedIn: true,
                loggedAffiliate: action.payload ? action.payload.data : {}
            };
        case actionType.AFFILIATE_LOGOUT:
            return {
                ...state,
                isAffiliateLoggedIn: false,
                loggedAffiliate: {},
                orders: [],
                orderCount: { completed: 0, pending: 0 }
            };
        case actionType.GET_AFFILIATE_PROFILE:
        case actionType.GET_AFFILIATE_ORDERS:
        case actionType.GET_AFFILIATE_ORDERS_COUNT:
            return {
                ...state,
                isLoading: true
            };
        case actionType.GET_AFFILIATE_PROFILE_FAILURE:
        case actionType.GET_AFFILIATE_ORDERS_FAILURE:
        case actionType.GET_AFFILIATE_ORDERS_COUNT_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.GET_AFFILIATE_PROFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                loggedAffiliate: action.payload ? action.payload.data : {}
            };
        case actionType.GET_AFFILIATE_ORDERS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                orders: action.payload ? action.payload.data : []
            };
        case actionType.GET_AFFILIATE_ORDERS_COUNT_SUCCESS:
            return {
                ...state,
                isLoading: false,
                orderCount: action.payload ? action.payload.data : { completed: 0, pending: 0 }
            };
        case actionType.AFFILIATE_FORGOT_PASSWORD:
            return {
                ...state,
                isLoading: true,
                isSent: false
            };
        case actionType.AFFILIATE_FORGOT_PASSWORD_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.AFFILIATE_FORGOT_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isSent: true
            };
        case actionType.AFFILIATE_RESET_PASSWORD:
            return {
                ...state,
                isLoading: true,
                isReset: false
            };
        case actionType.AFFILIATE_RESET_PASSWORD_FAILURE:
            return {
                ...state,
                isLoading: false
            };
        case actionType.AFFILIATE_RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                isReset: true
            };
        default:
            return state;
    }
}